import useApiHelpers from "@/composables/api/helpers";

const { getRequest } = useApiHelpers();

export default () => {
  const getSiftData = async () => {
    const response = await getRequest(`/sift`);
    return response.data;
  };
  return {
    getSiftData,
  };
};
